import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MyNavbar from '../components/MyNavbar.js';
import OffersContent from '../components/OffersContent.js';
import Connect from '../components/Connect.js';
import FooterHelp from '../components/FooterHelp.js';
import FooterBottom from '../components/FooterBottom.js';
import styled from 'styled-components';
import media from '../MediaQueries.js';

export default class Offers extends Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render () {
  	return (
      <div>
        <OffersContent />
      </div>
  	);
  }
}



// WEBPACK FOOTER //
// ./src/pages/Offers.js